export const wrapperIdentifier = 'contributions';

export interface Contribution {
  id: string;
  [k: string]: any;
}
